import { cn } from "@pcln/horizon";
const multiHotelGridContainer = [
    'grid grid-cols-1 gap-4 auto-rows-auto',
    "[grid-template-areas:'repeat-form-controls'_'add-hotel'_'travelers-submit']",
    '@3xl:grid-cols-2 @3xl:gap-4',
    "@3xl:[grid-template-areas:'repeat-form-controls_repeat-form-controls'_'add-hotel_.'_'travelers-submit_travelers-submit']",
    '@7xl:grid-cols-[1fr_1fr_1fr_1fr_1fr] @7xl:gap-y-4',
    "@7xl:[grid-template-areas:'repeat-form-controls_repeat-form-controls_repeat-form-controls_repeat-form-controls_repeat-form-controls'_'add-hotel_._._._.'_'travelers-submit_travelers-submit_travelers-submit_travelers-submit_travelers-submit']"
];
const multiHotelFormSlots = {
    formContainer: 'search-form-container @container w-auto',
    gridContainer: 'grid-container grid w-full [grid-area:grid-container]',
    datePicker: 'date-picker',
    submitButton: '',
    travelersSubmitContainer: 'travelers-submit-container [grid-area:travelers-submit] grid grid-cols-1 gap-3 @3xl:grid-cols-2',
    travelersWrapper: 'w-full',
    repeatFormControls: "repeat-form-controls [grid-area:repeat-form-controls] grid grid-cols-1 auto-rows-auto gap-6 [grid-template-areas:'hotel-multi']",
    hotelMulti: 'hotel-multi [grid-area:hotel-multi] grid grid-cols-1 gap-3',
    addHotelButton: 'btn-add-hotel @3xl:max-w-[200px] justify-self-start [grid-area:add-hotel]',
    hotelRow: 'w-full flex flex-col gap-3',
    hotelHeader: 'flex flex-row items-center justify-start gap-3',
    hotelInputsGrid: 'hotel-inputs grid grid-cols-1 gap-3 @3xl:grid-cols-2'
};
const getMultiHotelFormContainerClass = ()=>multiHotelFormSlots.formContainer;
const getMultiHotelGridContainerClass = ()=>cn(multiHotelFormSlots.gridContainer, multiHotelGridContainer);
const getMultiHotelInputClass = (type)=>{
    const inputMap = {
        datePicker: multiHotelFormSlots.datePicker,
        submit: multiHotelFormSlots.submitButton,
        repeatFormControls: multiHotelFormSlots.repeatFormControls,
        hotelMulti: multiHotelFormSlots.hotelMulti,
        addHotelButton: multiHotelFormSlots.addHotelButton,
        travelersSubmitContainer: multiHotelFormSlots.travelersSubmitContainer,
        travelersWrapper: multiHotelFormSlots.travelersWrapper,
        hotelRow: multiHotelFormSlots.hotelRow,
        hotelHeader: multiHotelFormSlots.hotelHeader,
        hotelInputsGrid: multiHotelFormSlots.hotelInputsGrid
    };
    return inputMap[type];
};
export { getMultiHotelFormContainerClass, getMultiHotelGridContainerClass, getMultiHotelInputClass };
